import React, { useState, useRef } from "react";
import "./App.css";
import Snowfall from "./components/Snowfall";
import ShootingStars from "./components/ShootingStars";
import BackgroundMusic from "./components/BackgroundMusic";

function App() {
  const [entered, setEntered] = useState(false);
  const [musicPlaying, setMusicPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  const handleEnter = () => {
    setEntered(true);
    // Start HTML5 audio on user interaction (works on iOS)
    const audio = audioRef.current;
    if (audio) {
      audio.volume = 0.3;
      audio.play().catch((e) => {
        console.warn("Audio play failed:", e);
      });
    }
  };

  return (
    <>
      {/* Audio element always mounted */}
      <audio
        ref={audioRef}
        src={process.env.PUBLIC_URL + "/sounds/bg.mp3"}
        loop
        preload="auto"
      />

      {!entered ? (
        <div className="App splash-screen" onClick={handleEnter}>
          <div className="noise-overlay"></div>
          <div className="dot-pattern"></div>
          <div className="splash-content">
            <div className="enter-button">
              <div className="sound-waves">
                <svg className="wave-svg" viewBox="0 0 100 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect className="wave-bar wb-1" x="10" y="14" width="4" height="12" rx="2" fill="currentColor" />
                  <rect className="wave-bar wb-2" x="20" y="8" width="4" height="24" rx="2" fill="currentColor" />
                  <rect className="wave-bar wb-3" x="30" y="4" width="4" height="32" rx="2" fill="currentColor" />
                  <rect className="wave-bar wb-4" x="40" y="10" width="4" height="20" rx="2" fill="currentColor" />
                  <rect className="wave-bar wb-5" x="50" y="2" width="4" height="36" rx="2" fill="currentColor" />
                  <rect className="wave-bar wb-6" x="60" y="10" width="4" height="20" rx="2" fill="currentColor" />
                  <rect className="wave-bar wb-7" x="70" y="4" width="4" height="32" rx="2" fill="currentColor" />
                  <rect className="wave-bar wb-8" x="80" y="8" width="4" height="24" rx="2" fill="currentColor" />
                  <rect className="wave-bar wb-9" x="90" y="14" width="4" height="12" rx="2" fill="currentColor" />
                </svg>
              </div>
              <span className="enter-text">tap to enter</span>
            </div>
          </div>
        </div>
      ) : (
        <div className={`App ${musicPlaying ? "music-active" : ""}`}>
          <div className="noise-overlay"></div>
          <div className="dot-pattern"></div>
          <div className="pulse-ring pulse-ring-1"></div>
          <div className="pulse-ring pulse-ring-2"></div>
          <div className="pulse-ring pulse-ring-3"></div>
          <div className="ambient-glow"></div>
          <Snowfall />
          <ShootingStars />
          <BackgroundMusic audioRef={audioRef} onPlayStateChange={setMusicPlaying} />

          <main className="main-content">
            <div className="hero-section">
              <div className="content-card">
                <div className="title-link">
                  <h1 className="title">Omer</h1>
                </div>
              </div>
            </div>
          </main>
        </div>
      )}
    </>
  );
}

export default App;
